var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ma-auto",style:({ maxWidth: this.isSquare ? '150px' : 'min(350px, 60%)' })},[_c('btn-layout',{attrs:{"item":_vm.item}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }